import { basePath } from "@/environment";
import { closeConnection as closeNatsConnection } from "@/nats";
import AuthService from "@/services/auth.service";
import { useAppStore } from "@/stores";

/* eslint-disable no-bitwise */
export function generateId() {
  return "xxxxxxxxxxxxxxxyxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
/* eslint-enable no-bitwise */

export async function logoutAndRedirect(router) {
  const redirectUrl = await logout();
  if (redirectUrl) {
    window.location.assign(redirectUrl);
  } else if (router) {
    router.push({ name: "login" });
  } else {
    window.location.assign(`${basePath()}login`);
  }
}

export async function logout() {
  const appStore = useAppStore();
  if (appStore.wsconnection?.isOpen) {
    appStore.closeConnection();
  }
  await closeNatsConnection();
  const res = await AuthService.logout();
  return res.data.redirectUrl;
}

export function userLocale() {
  return navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language || "en";
}

/**
 * Downloads a file with the given filename using the provided data.
 *
 * @param {string} fileName - The desired filename for the downloaded file.
 * @param {Blob} data - The file content.
 * @returns {void}
 */
export function downloadFile(fileName, data) {
  const url = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
